uvex-youtube-video {
  display: block;
  background: #666;
}
uvex-youtube-video .consent-layer {
  background-color: rgba(0, 0, 0, 0.5);
  color: #fff;
  padding: 1rem 5%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  cursor: pointer;
}